export default ".img__width {\n  width: 150px;\n}\n\n.text-width {\n  font-size: 12px;\n  width: 550px;\n}\n";